import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Button
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';
import BatchDetails from './BatchDetails';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'batchnu', label: 'Claim #', alignRight: true },
  { id: 'docode', label: 'Patient Name #', alignRight: false },
  { id: 'doccode', label: 'Provider', alignRight: false },
  { id: 'startc', label: 'Scheme', alignRight: true },
  { id: 'serty2', label: 'Service Type', alignRight: true },
  { id: 'doccode3', label: 'Gross Total', alignRight: true },
  { id: 'startc4', label: 'Awarded', alignRight: true },
  { id: 'batchnu5', label: 'Pay Date', alignRight: true },
  { id: 'docode6', label: 'Claim Status', alignRight: true },
  { id: 'doccode7', label: 'Invoice #', alignRight: true },
  { id: 'endc', label: 'Self Pmt?', alignRight: true },
  { id: '' },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClaimsSelect() {
  const { batchNo, setClaimNo, clearClaims, currentBatch, currentClaim, getClaimById } =
    useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();

  console.log('currentBatch in List', currentBatch);

  useEffect(() => {
    getBatchClaims();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getBatchClaims();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClaim]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getBatchClaims = async () => {
    setLoading(true);
    console.log('received batchNo', batchNo);
    await axios(`${baseUrl}/api/Claims/getClaimsDetailed?batchId=${batchNo}&clientRefId=0`).then(
      (res) => {
        setLoading(false);
        console.log('returned getBatchClaims', res);
        setDataList(res.data.result);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const adjudicate = async () => {
    setLoading(true);
    const userId = sessionStorage.getItem('oldRefId');
    console.log('received batchNo', batchNo);
    await axios
      .post(`${baseUrl}/api/Claims/runAdjudication?batchNo=${batchNo}&claimNo=0&user_id=${userId}`)
      .then(
        (res) => {
          setLoading(false);
          navigate(`/claims/selectbatch`);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Run Adjudication failed!: ${error}`, 'error');
        }
      );
  };

  const reverseadjudicate = async () => {
    setLoading(true);
    const userId = sessionStorage.getItem('oldRefId');
    console.log('received batchNo', batchNo);
    await axios
      .post(
        `${baseUrl}/api/Claims/reverseAdjudication?batchNo=${batchNo}&claimNo=0&user_id=${userId}`
      )
      .then(
        (res) => {
          setLoading(false);
          navigate(`/claims/selectbatch`);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Reversen Adjudication failed!: ${error}`, 'error');
        }
      );
  };

  const handleClaimDelete = async (e) => {
    console.log('e here', e.claim_ID);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/claims/deleteClaim?claimId=${e.claim_ID}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Claim!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Claim Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Claim!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleClaimView = (e) => {
    console.log('e claimId', e.row.claim_ID);
    console.log('e claim#', e.row.claim_No);
    setClaimNo(e.row.claim_ID);
    getClaimById(e.row.claim_ID);
    openView(e.row.claim_No);
  };

  const openView = (e) => {
    navigate(`/claims/claim/${e}`);
  };

  const openNew = () => {
    clearClaims();
    navigate(`/claims/claim/${0}`);
  };

  const openNewSelf = () => {
    clearClaims();
    navigate(`/claims/processClaim/${0}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Typography component="span" variant="h6" gutterBottom>
        Batch Header
      </Typography>
      <BatchDetails />

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 3 }}>
        <Typography component="span" variant="h6" gutterBottom>
          Claim Entries
        </Typography>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<PostAddIcon />}
          disabled={currentBatch.batchStatus_Id !== 3}
          onClick={() => reverseadjudicate()}
        >
          Rollback Adjud
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<PostAddIcon />}
          disabled={currentBatch.batchStatus_Id !== 2}
          onClick={() => adjudicate()}
        >
          Adjudication
        </Button>
        {(currentBatch.isSelfPayment === true || currentBatch.provider_Id === 0) && (
          <Button
            type="button"
            variant="outlined"
            color="secondary"
            startIcon={<PostAddIcon />}
            disabled={currentBatch.batchStatus_Id !== 1}
            onClick={() => openNewSelf()}
          >
            Add Self/Ind Claim
          </Button>
        )}
        {currentBatch.isSelfPayment === false && currentBatch.provider_Id > 0 && (
          <Button
            type="button"
            variant="outlined"
            color="secondary"
            startIcon={<PostAddIcon />}
            disabled={currentBatch.batchStatus_Id !== 1}
            onClick={() => openNew()}
          >
            Add Claim
          </Button>
        )}
      </Stack>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const {
                    claim_ID,
                    patientName,
                    provider,
                    scheme,
                    serviceType,
                    grossTotal,
                    awardTotal,
                    payDate,
                    claimStatus,
                    invoice_No,
                    diagnosis,
                    self_Payment,
                    status_Id
                  } = row;
                  const isItemSelected = selected.indexOf(claim_ID) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={claim_ID}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />
                      <TableCell align="right">{claim_ID}</TableCell>
                      <TableCell align="left">{patientName}</TableCell>
                      <TableCell align="left">{provider}</TableCell>
                      <TableCell align="left">{scheme}</TableCell>
                      <TableCell align="right">{serviceType}</TableCell>
                      <TableCell align="right">{grossTotal.toFixed(2)}</TableCell>
                      <TableCell align="right">{awardTotal.toFixed(2)}</TableCell>
                      <TableCell component="th" scope="row" padding="none">
                        {moment(payDate).isValid() ? moment(payDate).format('YYYY-MM-DD') : ''}
                      </TableCell>
                      <TableCell align="left">{claimStatus}</TableCell>
                      <TableCell align="right">{invoice_No}</TableCell>
                      <TableCell align="right">{self_Payment ? 'Yes' : 'No'}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleClaimView({ row })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                      </TableCell>
                      <TableCell align="right">
                        {claimStatus === 'In Process' && (
                          <IconButton
                            onClick={() =>
                              setConfirmDialog({
                                isOpen: true,
                                title: 'Are you sure you want to Delete Claim',
                                subTitle: "You can't undo this action",
                                heading: 'Delete Claim',
                                color: '#00000',
                                onConfirm: () => {
                                  handleClaimDelete({ claim_ID });
                                }
                              })
                            }
                          >
                            <DeleteForeverIcon sx={{ color: '#f44336' }} />
                          </IconButton>
                        )}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
